<template>
  <div :class="['app-container', { 'app-container_desktop': !isMobileDevice, 'app-container_mobile': isMobileDevice }]"
        id="app">
    <topbar/>
    <sidebar v-if="isAuth && !isMobileDevice"/>
    <router-view />
    <vuedal/>
  </div>
</template>

<script>
/**
 *  Базовый компонент всего приложения.
 */
import Sidebar from '@/components/Sidebar'
import Topbar from '@/components/Topbar'
import {Component as Vuedal} from 'vuedals'

export default {
  name: 'App',
  data () {
    return {
      /**
       *  Флаг, отвечающий за отображение бокового меню на мобильных устройствах.
       *  @type {Boolean}
       */
      isOpened: false
    }
  },
  components: {
    Topbar,
    Sidebar,
    Vuedal
  },
  mounted () {
    this.watchDeviceWidth()
    /**
     *  Так как боковое меню спозиционировано с помощью свойства position со значением fixed
     *  от верхнего края браузера задаётся отступ.
     *  В случае если содержимое страницы большое, то при прокрутки содержимого,
     *  необходимо данный отступ убирать.
     */
    window.addEventListener('scroll', () => {
      let scroll = window.pageYOffset || document.documentElement.scrollTop
      if (document.querySelector('.sidebar')) {
        if (scroll > 50) {
          document.querySelector('.sidebar').style.paddingTop = '0'
        } else {
          document.querySelector('.sidebar').style.paddingTop = '50px'
        }
      }
    })
  },
  computed: {
    /**
     *  Показываем сайдбар только когда пользователь авторизован.
     *  @returns {Boolean}
     */
    isAuth () {
      return this.$store.state.user.isAuth
    }
  }
}
</script>

<style src="@/assets/sass/style.scss" lang="scss"></style>



// WEBPACK FOOTER //
// src/App.vue